import { useEffect } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';
import user from 'js/lib/user';

import SessionStore from 'bundles/course-sessions/stores/SessionStore';
import { loadUserSessionGroupForCourse } from 'bundles/group-enroll/actions/GroupSettingActions';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';

export const useLoadCourseSessionGroup = () => {
  const courseId = useFluxibleStore(CourseStore, (store) => store.getCourseId());

  const { loading, sessionId } = useFluxibleStore(SessionStore, (store) => ({
    loading: !store.hasLoaded(),
    sessionId: store.getSessionId(),
  }));

  const executeAction = useFluxibleAction();

  useEffect(() => {
    if (courseId && !loading) {
      const userId = user.get().id.toString();
      executeAction(loadUserSessionGroupForCourse, { courseId, userId, sessionId });
    }
  }, [courseId, loading, sessionId, executeAction]);
};
